import type {ReactNode} from 'react';

type PillProps = {
    className: string;
    children: ReactNode;
};

export const Pill = ({ className, children }: PillProps) => (
    <div className={`inline-flex h-8 items-center justify-center rounded-lg px-3 ${className}`}>
        {children}
    </div>
);

type PillTextProps = {
    className?: string;
    children: React.ReactNode;
};

export const PillText = ({ className = "", children }: PillTextProps) => (
    <span
        className={[
            "whitespace-nowrap",
            "font-manager-acrom-ph-14-medium-acrom",
            "leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]",
            "text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]",
            "tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]",
            "font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]",
            "[font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]",
            className,
        ].join(" ").trim()}
    >
        {children}
    </span>
);
